import styled from 'styled-components';

import { Flex } from 'web-styled';
import Avatar from 'web-components/Avatar';

export const Header = styled(Flex).attrs({
  width: '100%',
  justify: 'space-between',
})`
  padding: 0 0 24px 0;
  border-bottom: 0.5px solid #c7c7cb;
`;

export const StyledAvatar = styled(Avatar).attrs({
  width: '80px',
  height: '80px',
})`
  border: 5px solid ${props => props.theme.colors.primary};
`;
